<template>
  <b-overlay :show="loading" class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12 g">
          <button
            class="btn btn-relief-primary"
            v-b-modal.modal-add-device
          >
            <i class="fa fa-plus"></i>
            إضافة جهاز جديد
          </button>
          <!-- basic modal -->
          <b-modal id="modal-add-device" title="إضافة جهاز جديد" hide-footer>
            <b-overlay :show="loading">
              <div class="form-group">
                <label for="">العنوان (اسم الجهاز)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="addDevice.title"
                  placeholder="اكتب هنا..."
                />
              </div>
              <div class="form-group">
                <label for="">نوع الجهاز</label>
                <select class="form-control" name="" id="" v-model="addDevice.type">
                  <option value="qrcode">ربط كجهاز مصاحب (الإفتراضي)</option>
                  <option value="meta">ربط مع Meta</option>
                </select>
              </div>
              <!-- <template v-if="addDevice.type == 'qrcode'">
                <h5 class="g">نوع الإرسال:</h5>
                <div class="form-check">
                  <h5 class="form-check-label">
                    <input type="radio" class="form-check-input" v-model="real_worker" value="no">
                    <strong>
                      الإرسال السريع
                    </strong>
                    <span class="text-muted">لرسائل التفعيل والتنبيهات.</span>
                  </h5>
                </div>
                <div class="form-check" style="margin-top: 5px">
                  <h5 class="form-check-label">
                    <input type="radio" class="form-check-input" v-model="real_worker" value="yes">
                    <strong>
                      الإرسال الآمن
                    </strong>
                    <span class="text-muted">للرسائل الجماعية.</span>
                  </h5>
                </div>
              </template><br> -->
              <div class="form-group" v-if="addDevice.type == 'meta'">
                <label for="">Access Token</label>
                <input type="text"
                  class="form-control" placeholder="" v-model="addDevice.token">
              </div>
              <div class="form-group" v-if="addDevice.type == 'meta'">
                <label for="">WhatsApp Business Account ID</label>
                <input type="text"
                  class="form-control" placeholder="" v-model="addDevice.account_id">
              </div>
              <div class="form-group" v-if="addDevice.type == 'meta'">
                <label for="">Phone number ID</label>
                <input type="text"
                  class="form-control" placeholder="" v-model="addDevice.phone_number_id">
              </div>
              <div class="col-12 text-center">
                <button class="btn btn-primary" @click="addDeviceNow()">
                  إضافة الجهاز
                </button>
              </div>
            </b-overlay>
          </b-modal>
          <!-- basic modal -->
          <b-modal
            id="modal-qrcode"
            v-if="current_device.qrcode"
            title="اتصال الجهاز"
            hide-footer
          >
            <div class="text-center col-12">
              <img
                v-if="current_device.qrcode.includes('https')"
                :src="current_device.qrcode"
                style="width: 50%; margin: 0px auto"
              />
              <img
                v-if="!current_device.qrcode.includes('https')"
                :src="qrcodeaftergenerate"
                style="width: 50%; margin: 0px auto"
              />
            </div>
            <br />
            <p></p>
          </b-modal>
        </div>
        <b-modal
            id="link"
            title="كيفية الربط"
            hide-footer
        >
            <h5>
                <div class="alert alert-info g text-center">
                    <span class="text-primary" v-if="current_device._id">
                        قم بإرسال رسالة الى هذا الرقم
                         من اي رقم آخر للتأكد من الربط بشكل سليم.
                    </span>
                </div>
            </h5>
        </b-modal>
        <b-modal id="how-1" title="كيفية الربط" hide-footer>
          <template v-if="current_device._id">
             <h5>
              1-
              من صفحة Configuration في Meta WhatsApp
              <br><br>
              2- قم بتعيين  Callback URL
              <br>
              <div class="alert alert-info g">
                  <span class="text-dark">https://server.smart-whats.com/user/meta/webhook</span>
              </div>
              3- قم بتعيين  Verify token
              <br>
              <div class="alert alert-info g">
                  <span class="text-dark">{{ current_device.meta.verify_token }}</span>
              </div>
          </h5>
          </template>
        </b-modal>
        <div
          class="col-12 col-lg-6"
          v-for="device in devices"
          :key="device._id"
        >
          <div class="card card-body text-center device">
            <div class="row">
              <div class="col-4 d-none d-lg-block text-center g c">
                <img v-if="device.status != 0 && device.type != 'meta' && device.info"
                  :src="device.info.image"
                  style="
                    width: 100%;
                    margin: 0px auto;
                    border-radius: 50%;
                    object-fit: cover;
                  "
                  alt=""
                />
                <div class="text-center col-12" v-if="device.status == 0 && device.type != 'meta'">
                <img
                  v-if="!device.qrcode.includes('https')"
                  :src="qrcodeaftergenerate"
                  alt="جاري التحميل..."
                  style="
                    width: 100%;
                    margin: 0px auto;
                    border-radius: 0;
                    border: 1px solid darkred;
                    padding: 1px;
                    object-fit: cover;
                  "
                />
              </div>
                <img v-if="device.type == 'meta'"
                  :src="require('@/assets/images/meta.jpeg')"
                  style="
                    width: 100%;
                    margin: 0px auto;
                    border-radius: 50%;
                    object-fit: cover;
                  "
                  alt=""
                />
              </div>
              <div class="col-12 col-lg-8 text-left g c">
                <h4
                  style="
                    margin: 0;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                  "
                >
                  <template v-if="device.slow_mode"><br>
                    <small class="border" style="color: green; padding: 4px; padding-right: 5px; padding-left: 5px; border-radius: 5px; background: #ffff">
                      <img :src="require('@/assets/images/slow_mode.png')" style="width: 24px; height: 24px;">
                      وضع الحماية فعال
                    </small><br>
                  </template>
                  {{ device.title }}
                  <br />
                  <small class="text-muted" v-if="device.info">{{ device.info.bio }}</small>
                </h4>
              </div>
            </div>
            <div class="card-footer text-left">
              <div class="col-12 table-responsive">
                <table class="table table-hover">
                  <tbody>
                    <tr>
                      <td>العنوان</td>
                      <td>{{ device.title }}</td>
                    </tr>
                    <tr v-if="device.type != 'meta'">
                      <td>حالة الإتصال</td>
                      <td>
                        <span
                          class="badge bg-warning"
                          v-if="device.status == 0"
                        >
                          <i class="fa fa-clock-o"></i>
                          لم يتصل بعد
                        </span>
                        <span
                          class="badge bg-success"
                          v-if="device.status == 1"
                        >
                          <i class="fa fa-check"></i>
                          متصل الآن
                        </span>
                        <span class="badge bg-danger" v-if="device.status == 2">
                          <i class="fa fa-times"></i>
                          قُطع الاتصال
                        </span>
                        <span class="badge bg-danger" v-if="device.status == 3">
                          <i class="fa fa-times"></i>
                          الرقم جديد!ّ ربما يتم حظره اذا تم الارسال منه
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>رقم الهاتف</td>
                      <td>{{ device.phone }}</td>
                    </tr>
                    <tr v-if="device.type == 'meta'">
                      <td>حالة الربط</td>
                      <td>
                        <span v-if="!device.meta.connect" class="text-info">
                          <i class="fa fa-clock-o"></i>
                          في الانتظار
                        </span>
                        <a href="javascript:;" v-if="!device.meta.connect" @click="current_device=device" v-b-modal.how-1>
                          <br>
                          <i class="fa fa-info-circle"></i>
                          كيفية الربط؟
                        </a>
                        <span v-if="device.meta.connect" class="text-success">
                          <i class="fa fa-check"></i>
                          تم الربط
                        </span>
                      </td>
                    </tr>
                    <tr v-if="device.type == 'meta'">
                      <td>حالة الإتصال</td>
                      <td>
                        <span v-if="!device.meta.link && !device.meta.connect" class="text-info">
                          <i class="fa fa-clock-o"></i>
                          قم بالربط أولاً
                        </span>
                        <span v-if="!device.meta.link && device.meta.connect" class="text-info">
                          <i class="fa fa-clock-o"></i>
                          في الانتظار
                        </span>
                        <a href="javascript:;" v-if="!device.meta.link && device.meta.connect" @click="current_device=device" v-b-modal.link>
                          <br>
                          <i class="fa fa-info-circle"></i>
                          كيفية التأكيد؟
                        </a>
                        <span v-if="device.meta.link" class="text-success">
                          <i class="fa fa-check"></i>
                          تم التأكيد
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>نوع الجهاز</td>
                      <td>
                        <span v-if="device.type == 'qrcode'" style="color: #4E71FF"><i class="fa fa-qrcode"></i> جهاز مُصاحب</span>
                        <img v-if="device.type == 'meta'" :src="require('@/assets/images/meta.png')" style="width: 60px">
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button
                          v-if="device.status == 0"
                          class="btn btn-sm text-success"
                          @click="current_device = device"
                          v-b-modal.modal-qrcode
                        >
                          <i class="fa fa-qrcode"></i>
                          إتصال / فحص الجهاز
                        </button>
                      </td>
                      <td>
                        <button
                          class="btn btn-sm text-danger"
                          @click="deleteDevice(device._id)"
                        >
                          <i class="fa fa-trash"></i>
                          حذف الجهاز
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <template v-if="device.type != 'meta'">
                  <button 
                    class="btn btn-block btn-default"
                    @click="restart(device._id)"
                    v-if="device.status == 1"
                  >
                    <i class="fa fa-refresh"></i>
                    إعادة تشغيل الخدمة
                  </button>
                  <button
                    class="btn btn-block btn-default btn-success"
                    @click="clean(device._id)"
                    v-if="device.status == 2 || device.status == 3"
                  >
                    <i class="fa fa-qrcode"></i>
                    إعادة الفحص من جديد
                  </button>
                </template>
                <template v-if="device.type == 'meta'">
                  <center>
                    تريد التحكم الكامل في الرقم واستقبال الرسائل؟
                    <br>
                    جرب خدمة
                    <a href="https://octowhats.com" target="_blank">
                      <img :src="require('@/assets/images/octo.png')" style="height: 36px" alt="">
                    </a>
                  </center>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { BOverlay, BModal, VBModal } from "bootstrap-vue";
var QRCode = require("qrcode");
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BOverlay,
    BModal,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data() {
    return {
      loading: true,
      addDevice: {type: 'qrcode'},
      current_device: {},
      real_worker: 'no',
      devices: [],
      inertValDevices: null,
      qrcodeaftergenerate: null,
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  beforeDestroy() {
    if (this.inertValDevices) {
      clearInterval(this.inertValDevices);
    }
  },
  created() {
    var g = this;
    g.getDevices();
    g.inertValDevices = setInterval(() => {
      if (g.current_device) {
        g.devices.forEach(async (element) => {
          if (g.current_device._id == element._id) {
            g.current_device = JSON.parse(JSON.stringify(element));
            g.qrcodeaftergenerate = await QRCode.toDataURL(
              g.current_device.qrcode
            );
          }
        });
      }
      g.getDevices(true);
    }, 5000);
  },
  methods: {
    getDevices(noload = false) {
      var g = this;
      if (!noload) {
        g.loading = true;
      }
      $.post(api + "/user/devices/list", {
        jwt: this.user.jwt,
      })
        .then(function (r) {
          g.devices = r.response;
          g.loading = false;
        })
        .catch(function () {
          g.loading = false;
          g.$toast({
            component: ToastificationContent,
            props: {
              title: "حدثت مشكلة في الاتصال",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    addDeviceNow() {
      var g = this;
      if (this.addDevice.title && this.addDevice?.title?.trim() != "") {
        this.loading = true;
        $.post(api + "/user/devices/add", {
          jwt: g.user.jwt,
          title: g.addDevice.title,
          type: g.addDevice.type,
          phone_number_id: g.addDevice.phone_number_id,
          real_worker: g.real_worker,
          token: g.addDevice.token,
          account_id: g.addDevice.account_id
        })
          .then(function (r) {
            g.loading = false;
            if (r.status == 100) {
              g.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم اضافة الجهاز بنجاح",
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
              location.reload();
            } else {
              g.$toast({
                component: ToastificationContent,
                props: {
                  title: r.response,
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          })
          .catch(function () {
            g.loading = false;
            g.$toast({
              component: ToastificationContent,
              props: {
                title: "حدثت مشكلة في الاتصال",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          });
      } else {
        g.$toast({
          component: ToastificationContent,
          props: {
            title: "برجاء كتابة العنوان",
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }
    },
    deleteDevice(id) {
      var g = this;
      if (confirm("متأكد من حذف الجهاز؟")) {
        $.post(api + "/user/devices/delete", {
          jwt: g.user.jwt,
          id: id,
        })
          .then(function () {
            g.getDevices();
          })
          .catch(function () {
            alert("حدث خطأ");
          });
      }
    },
    restart(id) {
      var g = this;
      if (confirm("متأكد من اعادة تشغيل الخدمة؟")) {
        $.post(api + "/user/devices/restart", {
          jwt: g.user.jwt,
          id: id,
        })
          .then(function () {
            g.getDevices();
          })
          .catch(function () {
            alert("حدث خطأ");
          });
      }
    },
    clean(id) {
      var g = this;
      if (confirm("متأكد من اعادة الفحص من جديد؟")) {
        $.post(api + "/user/devices/clean", {
          jwt: g.user.jwt,
          id: id,
        })
          .then(function () {
            g.getDevices();
          })
          .catch(function () {
            alert("حدث خطأ");
          });
      }
    },
  },
};
</script>

<style>
.device {
  border: 2px solid #999
}
</style>